import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";
import { SessionInvitationPayload } from "./SessionInvitationModal.d";

export const inviteToEphemeralSession = (
  sessionId: string,
  payload: SessionInvitationPayload,
  language: string,
  setLoading: Function,
  showAlert: Function | undefined,
  onSuccess: Function
) => {
  setLoading(true);
  ApiService.post(`ephemeral-evaluations/sessions/${sessionId}/attempts`, payload)
    .then((response) => {
      const { email_issues, invited_count } = response.data.invitations;
      const invitationMessage = translate(
        language,
        "PAGES.EPHEMERAL_SESSION.INVITATION.ALERTS.SUCCESS_MESSAGE"
      ).replace("{{COUNT}}", String(invited_count));

      onSuccess();
      showAlert?.({
        clickOutsideToClose: true,
        extraContent: email_issues.length
          ? `${invitationMessage} ${translate(
              language,
              "PAGES.EPHEMERAL_SESSION.INVITATION.ALERTS.EMAIL_ISSUES"
            )} ${email_issues.join(", ")}`
          : invitationMessage,
        title: translate(language, "PAGES.EPHEMERAL_SESSION.INVITATION.ALERTS.SUCCESS"),
        type: "success",
      });
    })
    .catch((error) => {
      console.error("Error inviting users to ephemeral session:", error);
      showAlert?.({
        clickOutsideToClose: true,
        title: translate(language, "PAGES.EPHEMERAL_SESSION.INVITATION.ALERTS.ERROR"),
        type: "danger",
      });
    })
    .finally(() => setLoading(false));
};
